/**
 * Videos d'Albalina : elles ne se lancent (et ne se telechargent) que lorsqu'elles
 * approchent de l'ecran, et se mettent en pause quand elles en sortent.
 *
 * Avant, chaque <video autoplay> de la page produit partait au chargement :
 * environ 6,5 Mo de videos en concurrence avec la premiere photo (rapport
 * PageSpeed du 5 oct. 2026). Les videos portent data-ab-paresseux, sans autoplay,
 * avec preload="none" : rien ne se telecharge avant d'etre a moins de 600 px de l'ecran.
 *
 * Les images de la galerie produit (sauf la premiere) sont en loading="lazy" cote Liquid. Des que la
 * cliente touche la page (ou 15 s apres le chargement), on les charge en arriere-plan pour qu'un balayage
 * rapide ou un clic sur une miniature lointaine ne montre pas de diapositive vide.
 */
(function () {
  var SELECTEUR = 'video[data-ab-paresseux]';

  function lancer(video) {
    var promesse = video.play();
    if (promesse && promesse.catch) promesse.catch(function () {});
  }

  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll(SELECTEUR).forEach(lancer);
    return;
  }

  var observateur = new IntersectionObserver(
    function (entrees) {
      entrees.forEach(function (entree) {
        // Un bord qui touche l'ecran compte comme « visible » avec un ratio de 0 : la 2e image de la galerie, collee a droite de l'ecran, partait ainsi.
        if (entree.isIntersecting && entree.intersectionRatio > 0) lancer(entree.target);
        else entree.target.pause();
      });
    },
    { rootMargin: '600px 0px', threshold: [0, 0.01] }
  );

  function suivre(racine) {
    if (racine.matches && racine.matches(SELECTEUR)) observateur.observe(racine);
    if (racine.querySelectorAll) racine.querySelectorAll(SELECTEUR).forEach(function (v) { observateur.observe(v); });
  }

  suivre(document);

  var galerieChargee = false;
  function precharger() {
    if (galerieChargee) return;
    galerieChargee = true;
    document.querySelectorAll('media-gallery .product-media__image[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
  }
  ['pointerdown', 'touchstart', 'keydown', 'wheel'].forEach(function (nom) {
    window.addEventListener(nom, precharger, { once: true, passive: true });
  });
  window.addEventListener('load', function () { setTimeout(precharger, 15000); });

  // La galerie est redessinee quand la cliente change de variante : on suit aussi les videos qui arrivent apres coup.
  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (n) { if (n.nodeType === 1) suivre(n); });
    });
  }).observe(document.body || document.documentElement, { childList: true, subtree: true });
})();
